import { createElement, styled, composedProps } from '@vebox/etui-system';

const LabelElement = createElement('label');
const Label = styled(LabelElement)(composedProps);
Label.displayName = 'Label';

export { Label };
